import { useState } from 'react';

import useBaVerificationStatsCard from '../BaDriverVerification/useBaVerificationStatsCard';
import useDriverOverviewData from '../companyInsight/useDriverOverviewData';
import useApprovedPartners from '../dashboard/useApprovedPartners';
import useDashboardData from '../dashboard/useDashboardData';
import useDispatcherVolumeChart from '../dashboard/useDispatcherVolumeChart';
import useDriverData from '../dashboard/useDriverStats';
import useRouteAnalysisChart from '../dashboard/useRouteAnalysisChart';
import useLookupMetrics from '../revenue/useLookupMetrics';
import useCurrentConfigData from './useCurrentConfig';

const useDashboardLoading = () => {
  const [loading, setLoading] = useState(false);
  const { driverData } = useDriverData();
  const { approvedPartners } = useApprovedPartners();
  const { lookupMetrics } = useLookupMetrics();
  const { dashboardData } = useDashboardData();
  const { routeAnalysisChartData } = useRouteAnalysisChart();
  const { dispatcherVolumeChartData } = useDispatcherVolumeChart();
  // const { lifeTimeOnboardingChart } = useLiftTimeOnboardingChart();
  const { getDriverOverviewData } = useDriverOverviewData();
  const { getCurrentConfigData } = useCurrentConfigData();
  const { getBaVerificationStats } = useBaVerificationStatsCard();

  const getDashboardLoadingData = async () => {
    setLoading(true);

    Promise.all([
      approvedPartners(),
      dashboardData(),
      lookupMetrics(),
      driverData(),
      // lifeTimeOnboardingChart(),
      getDriverOverviewData(),
      routeAnalysisChartData(),
      dispatcherVolumeChartData(),
      getCurrentConfigData(),
      getBaVerificationStats(),
    ])
      .then(() => setLoading(false))
      .catch(() => setLoading(false));
  };

  return { getDashboardLoadingData, loading };
};

export default useDashboardLoading;
